module.exports = __webpack_public_path__ + "static/media/diego.97a2bf32.png";